export const serviceCall = "call";
export const servicePackage = "package";
export const serviceSms = "sms";
